export enum FixedIncomeRedemptionSteps {
  QUOTATION = 1,
  QUOTATION_SUCCESS = 2,
  REDEMPTION_SUCCESS = 3,
  ACCEPT_QUOTATION = 11,
  CONFIRM_QUOTATION = 12,
  REDEMPTION_SUCCESS_QUOTATION = 13,
  QUOTATION_IN_PROGRESS = 21,
  ERROR = 99,
}
